import { deleteAuthToken } from 'library/FetchHelper'
import styled from 'styled-components'
import { Flex } from 'widgets'
import ConnectWalletButton from 'components/ConnectWalletButton'
import { Modal, Switch, Tooltip } from 'antd'
import { TOKEN_BUSD } from 'config/constants'
import { loadBlockchainData } from 'hooks/setGetBalance'
import useAuth from 'hooks/useAuth'
import { useCreateTokenContract } from 'hooks/useContract'
import useToast from 'hooks/useToast'
import { useCallback, useEffect, useState } from 'react'
import LogOut from 'widgets/Svg/Icons/LogOut'
import { formatNumber } from 'utils/formatBalance'
import { useFormatCurrency } from 'hooks/useFormatCurrency'
import { useSelector } from 'react-redux'
import { useWeb3React } from '@web3-react/core'
import { compactAddress } from 'helpers'
import Link from 'next/link'
import Avatar from 'components/Avatar'

const Wrapper = styled.div<{ visible: boolean }>`
  position: fixed;
  width: 100vw;
  height: 100vh;
  padding: 90px 0;
  z-index: 900;
  overflow: auto;
  transition: 0.25s;
  transform: ${({ visible }) => (visible ? 'translateX(0)' : 'translateX(100%)')};
  background: #f8f8f8;
`

const MenuActionsMobile = styled.div`
  position: relative;
  width: 100%;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  gap: 12px;
  .menu-mobile-items {
    padding-top: 8px;
    cursor: pointer;
    align-items: center;
    min-width: 90%;
    margin: auto 12px;
    .menu-mobile-language-item {
      .menu-mobile-item-left {
        max-width: 60%;
        min-width: 54%;
        align-items: center;

        span {
          font-size: 20px;
        }
        a {
          display: flex;
          gap: 12px;
          align-items: center;
        }
        img {
          width: 12px;
        }
      }
      .menu-mobile-item-left {
        margin-top: -18px;
      }
    }
  }
  .menu-mobile-total-balance {
  }

  .header-wallet {
    display: flex;
    min-width: 90%;
    margin: auto 12px;
    height: 78px;
    border-radius: 12px;
    box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
    margin-bottom: 12px;
    justify-content: center;
    .content {
      gap: 12px;
      img {
        width: 25px;
        height: 25px;
      }
      font-size: 12px;
      font-weight: 400;
    }
  }
  .btn-reload {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    min-height: 16px;
    padding: 3px;
    margin-left: 5px;
    margin-top: 3px;

    &:hover {
      background: linear-gradient(143.11deg, #006dfe 21.44%, #43e8e1 126.28%);
    }

    img {
      width: 100%;
      margin-left: 1px;
    }

    &.loading {
      img {
        animation: rotateAround 1s infinite;
      }
    }
  }
  button {
    width: 100%;
    height: 36px;
    background: #d9d9d9;
    border: none;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 18px;
    text-align: center;
    color: #000;
    cursor: pointer;
    border-radius: 6px;
    &:hover {
      opacity: 0.8;
    }
  }
  .connect {
    button {
      background: linear-gradient(143.11deg, #006dfe 21.44%, #43e8e1 126.28%);
      color: white;
    }
  }

  .profile-item {
    font-size: 20px;
    min-height: 78px;
    cursor: pointer;
    display: flex;
    align-items: center;
    width: 90%;
    margin: 0 auto;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.7);
    gap: 12px;
    img {
      height: 46px;
      margin-left: 15%;
    }
    img:first-child {
      display: none;
    }
  }
  .profile-item:nth-child(2),
  .profile-item:nth-child(3) {
    img {
      margin-left: calc(15% + 2px);
    }
  }
  .profile-item:hover {
    color: #006dfe;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.7);
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(5px);
    img:first-child {
      display: inline;
    }

    img:nth-child(2) {
      display: none;
    }
  }
  .item-profile {
  }
`

const ContentModal = styled.div`
  background-color: #fff;
  background: #ffffff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.5);
  border-radius: 15px;
  overflow: hidden;

  .title-modal {
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    min-height: 48px;
    border-bottom: 1px solid #6d6d6d;

    p {
      font-style: normal;
      font-weight: 700;
      font-size: 24px;
      line-height: 30px;
      text-align: center;
      color: #006dfe;
    }
  }

  .body-modal {
    .control-body-modal {
      display: flex;
      align-items: center;

      button {
        position: relative;
        background: transparent;
        width: 50%;
        height: 60px;
        border: none;
        border-bottom: 2px solid #d9d9d9;
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 18px;
        text-align: center;
        color: #6d6d6d;
        cursor: pointer;

        span {
          position: absolute;
          left: 50%;
          bottom: 0;
          transform: translate(-50%, -3px);
          display: block;
          max-width: 92px;
          margin: auto;
          font-family: 'Inter';
          font-style: normal;
          font-weight: 400;
          font-size: 12px;
          line-height: 15px;
          text-align: center;
          color: #ffffff;
          background: #006dfe;
          border-radius: 5px;
          padding: 1px 3px;
        }

        &.active {
          color: #000000;
          border-bottom: 2px solid #006dfe;
        }
      }
    }

    .content-body-modal {
      padding: 30px 15px;
      max-width: 404px;
      margin: 0 auto;
      text-align: center;

      img {
        margin-bottom: 16px;
      }

      > p {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 19px;
        color: #000000;
        margin-bottom: 19px;
      }

      .copy-address {
        display: flex;
        align-items: center;
        width: 100%;
        flex: 1;

        p {
          font-family: 'Inter';
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 19px;
          color: #a7a7a7;
          width: 100%;
          height: 36px;
          overflow: hidden;
          padding: 8px 10px;
          text-overflow: ellipsis;
          white-space: nowrap;
          border: 1px solid #c7c7c7;
          border-radius: 5px;
          margin-right: 5px;
        }

        button {
          height: 36px;
          width: 74px;
          background: #006dfe;
          border-radius: 5px;
          border: none;
          font-style: normal;
          font-weight: 700;
          font-size: 14px;
          line-height: 18px;
          text-align: center;
          color: #ffffff;
          cursor: pointer;

          &:hover,
          &:active {
            background: linear-gradient(143.11deg, #006dfe 21.44%, #43e8e1 126.28%);
            border-radius: 5px;
          }
        }
      }
    }
  }

  .mr-1 {
    margin-right: 7px;
  }
  @media (max-width: 572px) {
    position: fixed;
    width: 100%;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 0%);
    border-radius: 0;
    .ant-modal-close {
      display: none;
    }
  }
`

const visible = true
const initBalance = {
  BNB: 0,
  BUSD: 0,
}
const RedirectProfile = () => {
  const { logout } = useAuth()
  const { userInfo } = useSelector((state: any) => state.user)

  const { account } = useWeb3React()
  const accountEllipsis = account ? compactAddress(account) : null
  const { isLogin } = useSelector((state: any) => state.auth)
  const { currencyRate } = useSelector((state: any) => state.balances)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [visibleDropdown, setVisibleDropdown] = useState(false)
  const [copyText, setCopyText] = useState(false)

  const { toastSuccess }: any = useToast()
  const tokenContract = useCreateTokenContract(TOKEN_BUSD)
  const [balance, setBalance] = useState<any>(initBalance)
  const [getFormatCurrency] = useFormatCurrency()

  const getBalance = useCallback(async () => {
    if (isLogin) {
      const balanceBUSD = account ? await tokenContract.balanceOf(account) : 0
      setBalance({ BNB: await loadBlockchainData(account), BUSD: parseInt(balanceBUSD?.toString(), 10) / 10 ** 9 })
    } else {
      setBalance(initBalance)
    }
  }, [account, tokenContract, isLogin])
  const [loading, setLoading] = useState(false)

  const reloadBalance = () => {
    setLoading(true)
    setTimeout(() => setLoading(false), 1000)
    getBalance()
  }
  useEffect(() => {
    if (account) {
      getBalance()
    }
  }, [account, getBalance])

  const showModal = () => {
    setIsModalOpen(true)
  }
  const handleOk = () => {
    setIsModalOpen(false)
  }

  const handleCancel = () => {
    setIsModalOpen(false)
  }

  const handleCopy = (address: string) => {
    setCopyText(true)

    navigator.clipboard.writeText(address)
    setTimeout(() => {
      setCopyText(false)
    }, 3000)
  }
  return (
    <Wrapper visible={visible}>
      <MenuActionsMobile>
        <Link href="/account" passHref>
          <Flex className="profile-item">
            <div style={{ margin: '0 5px 0 10%' }}>
              <Avatar
                avatar={(isLogin && userInfo?.data?.profile?.avatar) || '/images/account/avatar-image-default.png'}
                height="64px"
                width="64px"
                transform="scale(0.48) translate(-32%,-46%)"
              />
            </div>
            <span>My Account</span>
          </Flex>
        </Link>
        <Link href="/account/my-nfts" passHref>
          <Flex className="profile-item">
            <img src="/images/account/icons/my-nft-blue.svg" alt="" />
            <img src="/images/account/icons/my-nft.svg" alt="" />
            <span>My NFT</span>
          </Flex>
        </Link>
        {/* <Flex className="profile-item">
          <img src="/images/account/icons/kyc-blue.svg" alt="" />
          <img src="/images/account/icons/kyc.svg" alt="" />
          <span>KYC</span>
        </Flex> */}
        <Link href="/account/more?action=favorite" passHref>
          <Flex className="profile-item">
            <img src="/images/account/icons/my-favorite-blue.svg" alt="" />
            <img src="/images/account/icons/my-favorite.svg" alt="" />
            <span>My Favorite</span>
          </Flex>
        </Link>

        {/* <Flex className="profile-item">
          <img src="/images/account/icons/my-watchlist-blue.svg" alt="" />
          <img src="/images/account/icons/my-watchlist.svg" alt="" />
          <span>My Watchlist</span>
        </Flex> */}
        <Link href="/settings" passHref>
          <Flex className="profile-item">
            <img src="/images/account/icons/settings-blue.svg" alt="" />
            <img src="/images/account/icons/settings.svg" alt="" />
            <span>Settings</span>
          </Flex>
        </Link>

        {account && isLogin ? (
          <div className="menu-mobile-items " style={{ padding: '24px 12px' }}>
            <button
              type="button"
              onClick={() => {
                logout()
                deleteAuthToken()
                toastSuccess('Logout successful')
              }}
            >
              Sign out
            </button>
          </div>
        ) : (
          <div className="menu-mobile-items connect" style={{ marginTop: '12px' }}>
            <ConnectWalletButton style={{ marginBottom: '12px' }} />
          </div>
        )}
      </MenuActionsMobile>
      <Modal
        width="483px"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={false}
        closeIcon={<img style={{ marginTop: '-17px', display: 'none' }} src="/images/header/close.svg" alt="" />}
      >
        <ContentModal>
          <div className="title-modal">
            <p>Add Funds</p>
          </div>

          <div className="body-modal">
            <div className="control-body-modal">
              <button className="active" type="button">
                <img className="mr-1" src="/images/header/arrow-down.svg" alt="" />
                Deposit Crypto
              </button>
              <button type="button">
                Buy with card <span>Comming soon</span>
              </button>
            </div>

            <div className="content-body-modal">
              <img src="/images/header/wallet.png" alt="" />

              <p>Transfer funds from an exchange or another wallet to your wallet address below:</p>

              <div className="copy-address">
                <p>{account}</p>
                <button type="button" onClick={() => handleCopy(account)} disabled={copyText}>
                  {copyText ? 'Copied' : 'Copy'}
                </button>
              </div>
            </div>
          </div>
        </ContentModal>
      </Modal>
    </Wrapper>
  )
}
export default RedirectProfile
